import React, {useState} from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Section, { Sections } from '../../Components/Containers/Section';
import { Link } from 'react-router-dom';
import Icon from '../../Components/Icons/Icon';
import ExportCustomers from '../Customers/Export';
import ExportPayments from '../Payments/Export';
import ExportExpenses from '../Expenses/Export';
import ExportOccurrences from '../Jobs/Export';
import Suggestion from '../More/Suggestion';
import NoItems from '../../Components/EmptyStates/NoItems';
import ExportInvoices from '../Customers/ExportInvoices';

const Reports = () => {
    const [exporting, setExporting] = useState(null);
    const [isSuggesting, setIsSuggesting] = useState(false);

    return <>
        <TopBar left="/more" title="Reports" />

        <Page>
            <Sections>
                <Section title="Reports">
                    <Menu items={[
                        {title: 'Overview', to: '/reports/overview'},
                        {title: 'Jobs', to: '/reports/jobs'},
                        {title: 'Invoices', to: '/reports/invoices'},
                        {title: 'Rounds', to: '/reports/rounds'},
                        {title: 'Payments', to: '/reports/payments'},
                        {title: 'Expenses', to: '/reports/expenses'},
                    ]} />
                </Section>

                <Section title="Download your data">
                    <Menu items={[
                        {title: 'Customers', export: () => setExporting('customers')},
                        {title: 'Invoices', export: () => setExporting('invoices')},
                        {title: 'Job history', export: () => setExporting('occurrences')},
                        {title: 'Payments', export: () => setExporting('payments')},
                        {title: 'Expenses', export: () => setExporting('expenses')},
                    ]} />
                </Section>
            </Sections>

            <NoItems
                title="Looking for something else?"
                message="If there's a report you'd like to see, let us know and we'll see what we can do."
                icon="MagnifyingGlassChart"
                onClick={() => setIsSuggesting(true)}
                short
            />

            <Suggestion isOpen={isSuggesting} setIsOpen={setIsSuggesting} />
        </Page>

        {exporting === 'customers' && <ExportCustomers isOpen={exporting === 'customers'} setIsOpen={setExporting} />}
        {exporting === 'invoices' && <ExportInvoices isOpen={exporting === 'invoices'} setIsOpen={setExporting} />}
        {exporting === 'occurrences' && <ExportOccurrences isOpen={exporting === 'occurrences'} setIsOpen={setExporting} />}
        {exporting === 'payments' && <ExportPayments isOpen={exporting === 'payments'} setIsOpen={setExporting} />}
        {exporting === 'expenses' && <ExportExpenses isOpen={exporting === 'expenses'} setIsOpen={setExporting} />}
    </>
}

const Menu = ({items}) => {
    return <ul className="divide-y divide-gray-200">
        {items.map((item, i) => {
            if (item.to) {
                return <li key={i}>
                    <Link className="flex w-full py-2" to={item.to}>
                        <span className="grow">{item.title}</span>
                        <Icon icon="RightChevron" />
                    </Link>
                </li>
            }
            if (item.export) {
                return <li key={i} className="flex w-full py-2 cursor-pointer" onClick={() => item.export()}>
                    <span className="grow">{item.title}</span>
                    <Icon icon="CloudArrowDown" />
                </li>
            }

            return null;
        })}
    </ul>
}

export default Reports;
